export default __webpack_public_path__ + "static/media/icon-youtube.e92719cf.svg";